/**
 *
 *
 * Usage:
 *
 *   data-sw-copy-edit-button
 *
 * @publishes copy-edit-button-enabled
 * @publishes copy-edit-button-disabled
 *
 *
 */

var sw = require('./../../lib/sw');
var $ = require('./../sw-jquery');

$(document).ready(function() {

  $('body').on('click', '[data-sw-copy-edit-button]', function() {
    var $this = $(this);

    if ($this.hasClass('btn-white')) {
      sw.trigger('copy-edit-button-enabled');
      $this.removeClass('btn-white').addClass('btn-secondary');
    } else {
      sw.trigger('copy-edit-button-disabled');
      $this.removeClass('btn-secondary').addClass('btn-white');
    }
  });

});
